<template>
    <transition
        v-bind="$attrs"
        v-bind:css="false"
        v-bind:mode="mode"
        v-bind:appear="appear"
        v-on:enter="type.enter"
        v-on:leave="type.leave"
        v-on:after-leave="$emit('after-leave')">
        <slot />
    </transition>
</template>

<script>
    import { TRANSITION_TYPE, getSLIDE_DOWN_UP, getFADE_IN_OUT } from "Util/animations";

    const TYPES = {
        [TRANSITION_TYPE.slide]: getSLIDE_DOWN_UP,
        [TRANSITION_TYPE.fade]: getFADE_IN_OUT
    };

    export default {
        props: {
            transition: { type: String, required: false, default: TRANSITION_TYPE.fade },
            afterEnter: { type: Function, required: false, default: null },
            afterLeave: { type: Function, required: false, default: null },
            mode: { type: String, required: false, default: null },
            appear: { type: Boolean, required: false, default: false },
            fast: { type: Boolean, required: false, default: false }
        },
        emits: ["after-leave"],
        computed: {
            type() {
                const multiplier = this.fast ? 0.25 : 1;
                const transitionFactory = TYPES[this.transition] || TYPES.fade;
                return transitionFactory(multiplier);
            }
        }
    };
</script>
